import React from 'react';

import SkeletonListing from 'Components/Skeleton/SkeletonListing';

/**
 * Category listing pages (StaticSearch) while they load: title, description, the filter and sort bar and the
 * product grid. Most of these pages have no take over banner, so the skeleton doesn't either. No slots.
 */
export default function CategoryPageSkeleton() {
  return (
    <div className="CategoryPageSkeleton">
      <SkeletonListing />
    </div>
  );
}
